import { ReactChild } from "react"
import { useLocation } from 'react-router-dom'
import '../components.scss'


type ContentProps = {
    children: ReactChild
}

export const Content: React.FC<ContentProps> = ({ children }) => {
    const location = useLocation();

    return (
        <div className={`content ${location.pathname.includes('stats') ? 'widther' : ''}`}>
            {children }
        </div>
    )
}